import { combineEpics } from 'redux-observable';
import { filter, map, mapTo, switchMap } from 'rxjs';
import { isOfType } from 'typesafe-actions';
import { catchAxiosError, catchUnauthorizedError, createEpic$ } from 'lib/store';
import { notificationError } from 'store/notifications';
import { systemUnauthorized } from 'store/system';
import {
  BankTransactionAction,
  bankTransactionError,
  bankTransactionListResponse,
} from './actions';

const bankTransactionErrorEpic$ = createEpic$(({ action$ }) =>
  action$.pipe(
    filter(isOfType(BankTransactionAction.Error)),
    mapTo(
      notificationError({
        caption: 'Error',
        duration: 10000,
        message: 'There was a problem loading bank transactions',
      }),
    ),
  ),
);

const bankTransactionRequestEpic$ = createEpic$(({ action$, getBankTransactionList$ }) =>
  action$.pipe(
    filter(isOfType(BankTransactionAction.ListRequest)),
    switchMap(action =>
      getBankTransactionList$(action.payload).pipe(
        map(bankTransactionListResponse),
        catchAxiosError(bankTransactionError),
        catchUnauthorizedError(systemUnauthorized),
      ),
    ),
  ),
);

export default combineEpics(bankTransactionErrorEpic$, bankTransactionRequestEpic$);
